import React, { useEffect, useState, useRef } from "react";
import styles from "./DataTable.module.css";
import { downloadPdf, formatDateAndTime } from "../../utils/utils";
import Spinner from "react-bootstrap/Spinner";
import AscIcon from "./../../public/images/sortAsc.svg";
import DescIcon from "./../../public/images/sortDesc.svg";
import config from "./../../public/images/cog.svg";
import Pagination from "../Pagination/Pagination";
import { IoIosAdd } from "react-icons/io";
import { CiEdit } from "react-icons/ci";
import { GrUpdate } from "react-icons/gr";
import download from "../../public/images/download.svg";
import { FcProcess } from "react-icons/fc";
import { FaRegEdit } from "react-icons/fa";
import { MdContentCopy } from "react-icons/md";
import { RiDeleteBin6Line } from "react-icons/ri";
import closeAccountIcon from "../../public/images/closeAccounts.svg";
import Button from "../../Common/Button";

export default function DataTable({
  columns,
  list = [],
  handleClickRow,
  onToggleOrder,
  rowClick,
  handleBankDetails,
  onToggleOrderByExpiry,
  handleDocumentDetails,
  handleEditClick,
  handleViewPlans,
  handleUpdatePartner,
  handleAddConfig,
  handleReuploadDocument,
  handleUpdateStatus,
  handleBankAccountDelete,
  handleBeneficiaryDelete,
  handleViewFeatures,
  handleEditRole,
  formatAllText = false,
  totalPages,
  currentPage,
  setCurrentPage,
  pagination = false,
  title = "",
  titleButton = null,
  titleDropdown = null,
  handleEditFollowupClick,
  handleAddHistory,
  enableCheckbox = false,
  selectedItems = [],
  onSelectionChange,
  submitButton = null,
  successMessage,
  errorMessage,
  handleUpdatePlan,
  handleUpdateCoupon,
  handleUpdatePartnerRates,
  handleEditPartner,
  handleCloseAccount,
  handleDuplicatePlan,
  enableInfiniteScroll = true,
  handleTransferNow,
  handleCommissionConfig,
  loading = false,
}) {
  const [data, setData] = useState(list);
  const [filteredData, setFilteredData] = useState(list);
  const [dataToShow, setDataToShow] = useState([]);
  const [searchTerms, setSearchTerms] = useState({});
  const [lastElement, setLastElement] = useState(null);
  const [dataLoading, setDataLoading] = useState(false);

  const observer = useRef(
    enableInfiniteScroll
      ? new IntersectionObserver(
          (entries) => {
            const first = entries[0];
            if (first.isIntersecting) {
              update();
            }
          },
          { root: document.querySelector("#scrollable"), threshold: 0.5 },
        )
      : null,
  );

  const formatText = (text) => {
    if (typeof text !== "string") return text;
    return text
      .toLowerCase()
      .replace(/_/g, " ")
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };

  const colText = (text, maxLength = 30) => {
    if (!text || typeof text !== "string") return text;

    if (text.length <= maxLength) return text;

    return text.substring(0, maxLength) + "...";
  };
  const handleCheckboxChange = (item, isChecked) => {
    if (onSelectionChange) {
      onSelectionChange(item, isChecked);
    }
  };
  const isItemSelected = (item) => {
    return selectedItems.some(
      (selected) =>
        (selected.accountNo && selected.accountNo === item.accountNo) ||
        (selected.beneficiaryId &&
          selected.beneficiaryId === item.beneficiaryId)
    );
  };
  useEffect(() => {
    if (!enableInfiniteScroll) return;
    const currentElement = lastElement;
    const currentObserver = observer.current;

    if (
      currentElement &&
      !dataLoading &&
      filteredData.length !== dataToShow.length
    ) {
      currentObserver.observe(currentElement);
    }

    return () => {
      if (currentElement) {
        currentObserver.unobserve(currentElement);
      }
    };
  }, [
    lastElement,
    filteredData,
    dataToShow,
    dataLoading,
    enableInfiniteScroll,
  ]);

  useEffect(() => {
    setData(list);
    setFilteredData(list);
    setDataToShow(list.slice(0, 20));
  }, [list]);

  useEffect(() => {
    const filtered = filterData();
    setFilteredData(filtered);
    setDataToShow(filtered);
  }, [searchTerms]);

  const filterData = () => {
    let filtered = [...data];
    Object.keys(searchTerms).forEach((key) => {
      if (searchTerms[key]) {
        filtered = filtered?.filter((item) => {
          const findcolumn = columns.find((col) => col.Header === key);
          if (!findcolumn) return true;
          const value = item[findcolumn.accessor];
          if (value != null) {
            if (key === "phone_num") {
              return value.includes(searchTerms[key]);
            } else {
              return value
                .toLowerCase()
                .includes(searchTerms[key].toLowerCase());
            }
          }
          return false;
        });
      }
    });
    return filtered;
  };

  const update = () => {
    if (!enableInfiniteScroll) return;
    if (dataLoading) return;
    if (dataToShow.length >= filteredData.length) return;
    setDataLoading(true);
    setTimeout(() => {
      setDataToShow((prevItems) =>
        prevItems.concat(
          filteredData.slice(prevItems.length, prevItems.length + 20),
        ),
      );
      setDataLoading(false);
    }, 1000);
  };

  const handleChange = (e) => {
    const { value, title } = e.target;

    setSearchTerms((prevTerms) => ({
      ...prevTerms,
      [title]: value,
    }));
  };
  const isActive = columns.some((column) => column.search);
  return (
    <div
      className={
        title === "Beneficiary List"
          ? styles.mainContainerv2
          : styles.mainContainer
      }
    >
      {/* {title !== "" && <div className={styles.heading}>{title}</div>} */}
      {title !== "" && (
        <div className={styles.headingWithButton}>
          <div>{title}</div>

          <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
            {titleDropdown && <div>{titleDropdown}</div>}
            {titleButton && <div>{titleButton}</div>}
          </div>
        </div>
      )}

      <div className={styles.tableContainer}>
        <table className={styles.myTable}>
          <thead className={styles.header}>
            <tr>
              {enableCheckbox && <th>Select</th>}
              {columns.map((item) => {
                if (item.accessor === "createdAt" && onToggleOrder) {
                  return (
                    <th key={item.Header}>
                      <span
                        style={{
                          marginRight: "2px",
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                        }}
                      >
                        {item.Header}
                        {item.sort === "ASC" ? (
                          <img
                            src={AscIcon}
                            alt="ascending_icon"
                            style={{
                              height: "25px",
                              width: "25px",
                              cursor: "pointer",
                            }}
                            onClick={onToggleOrder}
                          />
                        ) : (
                          <img
                            src={DescIcon}
                            alt="descending_icon"
                            style={{
                              height: "25px",
                              width: "25px",
                              cursor: "pointer",
                            }}
                            onClick={onToggleOrder}
                          />
                        )}
                      </span>
                    </th>
                  );
                }
                if (item.accessor === "expiry" && onToggleOrderByExpiry) {
                  return (
                    <th key={item.Header}>
                      <span
                        style={{
                          marginRight: "2px",
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                        }}
                      >
                        {item.Header}
                        {!item.orderBy ? (
                          <img
                            src={AscIcon}
                            alt="ascending_icon"
                            style={{
                              height: "25px",
                              width: "25px",
                              cursor: "pointer",
                            }}
                            onClick={onToggleOrderByExpiry}
                          />
                        ) : (
                          <img
                            src={DescIcon}
                            alt="descending_icon"
                            style={{
                              height: "25px",
                              width: "25px",
                              cursor: "pointer",
                            }}
                            onClick={onToggleOrderByExpiry}
                          />
                        )}
                      </span>
                    </th>
                  );
                }
                return (
                  <th key={item.Header}>
                    <span style={{ marginRight: "2px" }}>{item.Header}</span>
                  </th>
                );
              })}
            </tr>
            {isActive && (
              <tr className={styles.searchRow}>
                {columns.map((item, index) => (
                  <th key={index} style={{ padding: "5px 10px" }}>
                    {item.search ? (
                      <input
                        type={
                          item.Header === "Phone Number" ? "number" : "text"
                        }
                        className={styles.myInput}
                        placeholder="Search..."
                        title={item.Header}
                        onChange={(e) => handleChange(e)}
                      />
                    ) : null}
                  </th>
                ))}
              </tr>
            )}
          </thead>
          <tbody id="scrollable">
            {loading ? (
              <tr>
                <td
                  colSpan={columns.length}
                  style={{ textAlign: "center", padding: "20px" }}
                >
                  <Spinner animation="border" />
                </td>
              </tr>
            ) : dataToShow && dataToShow.length > 0 ? (
              dataToShow.map((item, itemIndex) => {
                return (
                  <tr
                    key={itemIndex}
                    className={`${styles.rowcell} ${rowClick ? styles.clickableRow : ""}`}
                    onClick={() => {
                      if (rowClick) handleClickRow(item);
                    }}
                    ref={
                      itemIndex === dataToShow.length - 1
                        ? setLastElement
                        : null
                    }
                  >
                    {enableCheckbox && (
                      <td>
                        <input
                          type="checkbox"
                          checked={isItemSelected(item)}
                          onChange={(e) =>
                            handleCheckboxChange(item, e.target.checked)
                          }
                          onClick={(e) => e.stopPropagation()}
                        />
                      </td>
                    )}
                    {columns.map((col, colIndex) => {
                      if (col.accessor === "partner") {
                        let partnerName = "-";
                        try {
                          if (typeof item.partner === "string") {
                            try {
                              const parsedPartner = JSON.parse(item.partner);
                              partnerName = parsedPartner?.name || "-";
                            } catch (jsonErr) {
                              partnerName = item.partner || "-";
                            }
                          } else if (
                            item.partner &&
                            typeof item.partner === "object"
                          ) {
                            partnerName = item.partner.name || "-";
                          }
                        } catch (err) {}

                        return <td key={colIndex}>{partnerName}</td>;
                      }
                      if (col.Cell) {
                        const value = col.Cell({ row: { original: item } });

                        return (
                          <td key={colIndex}>
                            {col.formatText && typeof value === "string"
                              ? formatText(value)
                              : value}
                          </td>
                        );
                      }

                      if (col.accessor === "details")
                        return (
                          <td>
                            <button
                              onClick={() => {
                                if (!rowClick) handleClickRow(item);
                              }}
                              className={styles.detailsBtn}
                            >
                              View Details
                            </button>
                          </td>
                        );
                      if (col.accessor === "viewPlans")
                        return (
                          <td>
                            <button
                              onClick={() => {
                                if (!rowClick) handleViewPlans(item);
                              }}
                              className={styles.detailsBtn}
                            >
                              View Plans
                            </button>
                          </td>
                        );
                      if (col.accessor === "viewFeatures")
                        return (
                          <td>
                            <button
                              onClick={() => {
                                if (!rowClick) handleViewFeatures(item);
                              }}
                              className={styles.detailsBtn}
                            >
                              View Features
                            </button>
                          </td>
                        );
                      if (col.accessor === "editRole")
                        return (
                          <td>
                            <button
                              onClick={() => {
                                if (!rowClick) handleEditRole(item);
                              }}
                              className={styles.detailsBtn}
                            >
                              Edit Role
                            </button>
                          </td>
                        );
                      if (col.accessor === "updatePartner")
                        return (
                          <td>
                            <button
                              onClick={() => {
                                if (!rowClick)
                                  handleEditPartner(item.erPartnerId);
                              }}
                              className={styles.detailsBtn}
                            >
                              Edit Partner
                            </button>
                          </td>
                        );
                      if (col.accessor === "documents")
                        return (
                          <td>
                            <button
                              onClick={() => {
                                if (!rowClick) handleDocumentDetails(item);
                              }}
                              className={styles.detailsBtn}
                            >
                              View Documents
                            </button>
                          </td>
                        );
                      if (col.accessor === "edit")
                        return (
                          <td>
                            <button
                              onClick={() => {
                                if (!rowClick) handleEditClick(item);
                              }}
                              className={styles.detailsBtn}
                            >
                              Edit Coupon
                            </button>
                          </td>
                        );
                      if (col.accessor === "actions") {
                        const { modifyAccess, writeAccess } = col;
                        return (
                          <td key={colIndex}>
                            <div
                              style={{
                                display: "flex",
                                gap: "10px",
                                justifyContent: "center",
                              }}
                            >
                              {modifyAccess && (
                                <button
                                  onClick={() => {
                                    if (!rowClick)
                                      handleEditFollowupClick(item);
                                  }}
                                  className={styles.iconButton}
                                  title="Change Status"
                                >
                                  <CiEdit size={20} />
                                </button>
                              )}
                              {writeAccess && (
                                <button
                                  onClick={() => {
                                    if (!rowClick) handleAddHistory(item);
                                  }}
                                  className={styles.iconButton}
                                  title="Add History"
                                >
                                  <IoIosAdd size={20} />
                                </button>
                              )}
                            </div>
                          </td>
                        );
                      }
                      if (col.accessor === "partnerAction")
                        return (
                          <td key={colIndex}>
                            <div
                              style={{
                                display: "flex",
                                gap: "10px",
                                justifyContent: "center",
                              }}
                            >
                              <button
                                onClick={() => {
                                  if (!rowClick) handleUpdateStatus(item);
                                }}
                                className={styles.iconButton}
                                title="Change Status"
                              >
                                <CiEdit size={20} />
                              </button>
                              <button
                                onClick={() => {
                                  if (!rowClick) handleUpdatePartner(item);
                                }}
                                className={styles.iconButton}
                                title="Update Partner"
                              >
                                <FaRegEdit size={18} />
                              </button>
                            </div>
                          </td>
                        );
                      if (col.accessor === "editPlan")
                        return (
                          <td>
                            <div
                              style={{
                                display: "flex",
                                gap: "10px",
                                justifyContent: "center",
                              }}
                            >
                              <button
                                onClick={() => {
                                  if (!rowClick) handleUpdatePlan(item);
                                }}
                                className={styles.iconButton}
                                title="Edit Plan"
                              >
                                <FaRegEdit size={18} />
                              </button>
                              <button
                                onClick={() => {
                                  if (!rowClick) handleDuplicatePlan(item.code);
                                }}
                                className={styles.iconButton}
                                title="Duplicate Plan"
                              >
                                <MdContentCopy size={18} />
                              </button>
                            </div>
                          </td>
                        );
                      if (col.accessor === "editCoupon")
                        return (
                          <td>
                            <button
                              onClick={() => {
                                if (!rowClick) handleUpdateCoupon(item);
                              }}
                              className={styles.iconButton}
                              title="Update Coupon"
                            >
                              <FaRegEdit size={18} />
                            </button>
                          </td>
                        );
                      if (col.accessor === "editPartnerRates") {
                        return (
                          <td key={colIndex}>
                            <button
                              onClick={() => {
                                if (!rowClick) handleUpdatePartnerRates(item);
                              }}
                              className={styles.iconButton}
                              title="Update Partner Rates"
                            >
                              <FaRegEdit size={18} />
                            </button>
                          </td>
                        );
                      }
                      // bank
                      if (col.accessor === "bankAccountDelete")
                        return (
                          <td key={colIndex}>
                            <div
                              style={{
                                display: "flex",
                                gap: "10px",
                                justifyContent: "center",
                              }}
                            >
                              <button
                                onClick={() => {
                                  if (!rowClick) handleBankAccountDelete(item);
                                }}
                                className={styles.iconButton}
                                title="Delete Bank Account"
                              >
                                <RiDeleteBin6Line size={20} />
                              </button>
                            </div>
                          </td>
                        );
                        if (col.accessor === "beneficiaryDelete")
                        return (
                          <td key={colIndex}>
                            <div
                              style={{
                                display: "flex",
                                gap: "10px",
                                justifyContent: "center",
                              }}
                            >
                            {item.status !== "DELETED" ? (
                              <button
                                onClick={() => {
                                  if (!rowClick) handleBeneficiaryDelete(item);
                                }}
                                className={styles.iconButton}
                                title="Delete Beneficiary"
                              >
                                <RiDeleteBin6Line size={20} />
                              </button>
                              ) : (
                                <span>--</span>
                              )}
                            </div>
                          </td>
                        );
                      if (col.accessor === "addConfig")
                        return (
                          <td>
                            <button
                              onClick={() => {
                                if (!rowClick) handleAddConfig(item);
                              }}
                              className={styles.detailsBtn}
                            >
                              Add Config
                            </button>
                          </td>
                        );
                         if (col.accessor === "reuploadDocument")
                        return (
                          <td>
                            <button
                              onClick={() => {
                                if (!rowClick) handleReuploadDocument(item);
                              }}
                              className={styles.detailsBtn}
                            >
                              Reupload Document
                            </button>
                          </td>
                        );
                      if (col.accessor === "closeAccount") {
                        return (
                          <td key={colIndex}>
                            <div
                              style={{
                                display: "flex",
                                gap: "10px",
                                justifyContent: "center",
                              }}
                            >
                              {item.status === "APPROVED" ? (
                                <button
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleCloseAccount(item);
                                  }}
                                  className={styles.iconButton}
                                  title="Close Account"
                                >
                                  <img
                                    src={closeAccountIcon}
                                    alt="Close Account"
                                    title="Close Account"
                                    width={22}
                                    height={22}
                                    style={{ fontWeight: "bold" }}
                                  />
                                </button>
                              ) : (
                                <span style={{ color: "#ccc" }}>--</span>
                              )}
                            </div>
                          </td>
                        );
                      }
                      if (col.accessor === "updatePlan")
                        return (
                          <td>
                            <button
                              onClick={() => {
                                if (!rowClick) handleClickRow(item);
                              }}
                              className={styles.detailsBtn}
                            >
                              Update Plan
                            </button>
                          </td>
                        );
                      if (col.accessor === "bankDetails")
                        return (
                          <td>
                            <button
                              onClick={() => {
                                if (!rowClick) handleBankDetails(item);
                              }}
                              className={styles.detailsBtn}
                            >
                              View Bank Details
                            </button>
                          </td>
                        );
                      if (col.accessor === "TransferNow") {
                        if (item.status !== "APPROVED") {
                          return <td>--</td>;
                        }

                        return (
                          <td>
                            <Button
                              title="Transfer Now"
                              classes={styles.iconButton}
                              onClick={(e) => {
                                e.stopPropagation();
                                if (!rowClick) handleTransferNow(item);
                              }}
                            />
                          </td>
                        );
                      }
                      if (col.accessor === "commissionConfig") {
                        if (item.status !== "APPROVED") {
                          return <td>--</td>;
                        }

                        return (
                          <td>
                            <button
                              onClick={(e) => {
                                e.stopPropagation();
                                if (!rowClick) handleCommissionConfig(item);
                              }}
                              className={styles.iconButton}
                              title="Transfer Fee Config"
                            >
                              <img
                                src={config}
                                alt="Transfer Fee Config"
                                width={20}
                                height={20}
                              />
                            </button>
                          </td>
                        );
                      }
                      if (col.accessor === "path")
                        return (
                          <td>
                            {item.status === "APPROVED" ? (
                              <img
                                src={download}
                                alt="download"
                                title="Download"
                                onClick={() => downloadPdf(item[col.accessor])}
                                width={30}
                                height={30}
                                style={{ cursor: "pointer" }}
                              />
                            ) : (
                              <FcProcess size={30} title="Processing" />
                            )}
                          </td>
                        );

                      if (
                        item[col.accessor] === null ||
                        item[col.accessor] === undefined
                      ) {
                        return <td key={colIndex}>--</td>;
                      }
                      if (col.accessor === "amount")
                        return <td>{`INR ${item[col.accessor]}`}</td>;
                      if (
                        col.accessor === "timeCreated" ||
                        col.accessor === "expiry" ||
                        col.accessor === "createdAt" ||
                        col.accessor === "tranWhen" ||
                        col.accessor === "created_at" ||
                        col.accessor === "created" ||
                        col.accessor === "transaction_created_at" ||
                        col.accessor === "start" ||
                        col.accessor === "end" ||
                        col.accessor === "fromDt" ||
                        col.accessor === "toDt" ||
                        col.accessor === "subscriptionStartDate" ||
                        col.accessor === "subscriptionRenewalDate" ||
                        col.accessor === "updatedAt" ||
                        col.accessor === "createdat"
                      )
                        return (
                          <td key={colIndex}>
                            {formatDateAndTime(item[col.accessor])}
                          </td>
                        );
                      // else return <td key={colIndex}>{item[col.accessor]}</td>;
                      // else return <td key={colIndex}>{formatText(item[col.accessor])}</td>;
                      return (
                        <td
                          key={colIndex}
                          title={
                            typeof item[col.accessor] === "string" &&
                            item[col.accessor].length > 30
                              ? item[col.accessor]
                              : ""
                          }
                        >
                          {col.formatText ||
                          (formatAllText && col.formatText !== false)
                            ? formatText(colText(item[col.accessor]))
                            : colText(item[col.accessor])}
                        </td>
                      );
                    })}
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={columns.length} style={{ textAlign: "center" }}>
                  No Data Found
                </td>
              </tr>
            )}

            {dataLoading && (
              <tr>
                <td colSpan={6} style={{ textAlign: "center" }}>
                  <Spinner animation="border" />
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {successMessage && (
        <div
          style={{
            textAlign: "center",
            color: "green",
            margin: "10px",
            padding: "5px",
          }}
        >
          {successMessage}
        </div>
      )}

      {errorMessage && (
        <div
          style={{
            textAlign: "center",
            color: "red",
            margin: "10px",
            padding: "5px",
          }}
        >
          {errorMessage}
        </div>
      )}
      {enableCheckbox && submitButton && (
        <div className={styles.submitButton}>{submitButton}</div>
      )}
      {pagination === true && totalPages > 1 && (
        <div className={styles.pagination}>
          <Pagination
            totalPages={totalPages}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
          />
        </div>
      )}
    </div>
  );
}
